import { useEffect, useState } from 'react';

export function CheckMobile(width) {
  const [isMobile, setIsMobile] = useState(() => {
    // Inicialización lazy — lee el valor real antes del primer render
    if (typeof window !== 'undefined') {
      return window.matchMedia(`(max-width: ${width}px)`).matches;
    }
    return false;
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${width}px)`);

    const handleResize = (event) => {
      setIsMobile(event.matches);
    };

    mediaQuery.addListener(handleResize);
    return () => mediaQuery.removeListener(handleResize);
  }, [width]);

  return isMobile;
}
